import React, { FC } from 'react'
import Routes from '@routes'
import 'react-perfect-scrollbar/dist/css/styles.css'

const App: FC = () => <Routes />

export default App
